import { gql } from '@apollo/client';

export default gql`
  mutation deleteEventsByIds($ids: [String]) {
    deleteEventsByIds(ids: $ids) {
      ok
      message
      data
      error
    }
  }
`;
